import { useTranslation } from "react-i18next";
import { formatDateAndTime } from "../../../../utils";
import { STATUS_OPTIONS } from "../../../../hooks/useOrderColumn";

/**
 * This component is status update card which shown in activity logs
 * @param param0 createdAt and value of status
 */
const UpdatedStatusLog = ({
  createdAt,
  value,
}: {
  createdAt: string;
  value?: string;
}) => {
  const { t } = useTranslation();
  return (
    <div className="card-auto p-24 my-10 row row-column gap-8">
      <div> {formatDateAndTime(createdAt, "DD.MM.YYYY HH:mm:ss")}</div>
      <div>
        {t("order")} <strong>{t("status")}</strong>
        <span> {t("changedTo")}</span> “
        {value && (
          <span
            style={{
              color:
                STATUS_OPTIONS.find((status) => status.key === value)?.color ??
                "#0071E3", // Uploaded
            }}
          >
            {t(
              STATUS_OPTIONS.find((status) => status.key === value)?.value ??
                value,
            )}
          </span>
        )}
        ”
      </div>
    </div>
  );
};

export default UpdatedStatusLog;
